export const Plataforma = {
    WEB: "WEB",
    MOVIL_WEB: "MOVIL_WEB",
    MOVIL_ANDROID: "MOVIL_ANDROID",
    MOVIL_IOS: "MOVIL_IOS"
}